import React from "react";
import { Heading } from "../Heading";
import { Button } from "../Button";
import { Modal } from "../Modal";

export type TConfirmationModal = {
    open: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    heading: string | JSX.Element;
    description?: string | JSX.Element;
    confirmBtnText: string;
    cancelBtnText?: string;
    removing: boolean;
    onConfirmClick: () => void;
    onCancelClick?: () => void;
    fromTop?: string;
    confirmBtnLoading?: boolean;
};

export const ConfirmationModal = ({
    open,
    onOpen,
    onClose = () => undefined,
    heading,
    description,
    confirmBtnText,
    cancelBtnText,
    removing,
    onCancelClick,
    onConfirmClick,
    fromTop,
    confirmBtnLoading = false,
}: TConfirmationModal) => {
    return (
        <Modal
            open={open}
            onOpen={onOpen}
            onClose={onClose}
            closeOnEscape={false}
            closeOnOutsideClick={false}
            closeBtn={false}
            fromTop={fromTop}
        >
            <Heading type="h3" children={heading} className="u-mt-0" />
            <div>{description}</div>
            <div className="u-d-flex u-justify-content-end u-mt-18">
                {onCancelClick && cancelBtnText && (
                    <Button type="secondary" buttonClassName="u-mr-12" onClick={onCancelClick}>
                        {cancelBtnText}
                    </Button>
                )}
                <Button type={removing ? "danger" : "primary"} onClick={onConfirmClick} loading={confirmBtnLoading}>
                    {confirmBtnText}
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;
